export const PRIMARY_POP_COLOR = '#D21F3C';
export const SECONDARY_POP_COLOR = '#FFA987';
export const LIGHT_NEUTRAL_COLOR = '#F6F1F0';
export const DARK_NEUTRAL_COLOR = '#444140';
export const DARK_GRAY = '#A9A9A9';

export const WHITE = '#FFFFFF';
export const BLACK = '#000000';

export const SUCCESS_COLOR = '#61994c';
export const WARNING_COLOR = '#de8914';
export const DANGER_COLOR = '#f44336';
